import clsx from "clsx";
import type { FC, ReactNode, Ref } from "react";

export type DualButtonProps = {
  buttonLeft: ReactNode;
  buttonRight: ReactNode;
  gap?: boolean;
  onClick?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  ref?: Ref<HTMLDivElement>;
};

/**
 * Pass in two instantiated MDS buttons to create a dual button.
 */
export const DualButton: FC<DualButtonProps> = ({
  ref,
  buttonLeft,
  buttonRight,
  onClick,
  onKeyDown,
  gap = false,
}) => {
  return (
    <div
      className={clsx("flex", gap && "gap-[1px]")}
      ref={ref}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <span className="[&_button]:rounded-r-none [&_button]:border-r-0">{buttonLeft}</span>
      <span className="[&_button]:rounded-l-none">{buttonRight}</span>
    </div>
  );
};

DualButton.displayName = "DualButton";
